<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getUserRoleTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button @click.native="createUserRole" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort_date == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort_date == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{data.role_name}}</td>
            <td>{{data.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showUserRoleData(data.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import IconPencil from "../../../components/Icon/icon-pencil";
  import CircleButton from "../../../components/Button/CircleButton";
  import InputTextField from "../../../components/Input/InputTextField";
  import InputSearch from "../../../components/Input/InputSearch";
  import Paginate from "../../../components/Layout/Paginate";
  import Loading from 'vue-loading-overlay';
  import Swal from "sweetalert";
  export default {
    name: "UserRoleTable",
    components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil, Loading },
    data() {
      return {
        title: "User role",
        isLoading: false,
        headers: [
          { id: 1, text: "No." ,icon : null},
          { id: 2, text: "Role name" ,icon : null},
          { id: 3, text: "Update date" ,icon : true},
          { id: 4, text: "Edit" ,icon : null},
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        search : '',
        sort_date : 'desc',
      };
    },
    created() {
      this.getUserRoleTable(1);
    },
    methods: {
      goToUserRoleEdit() {
        this.$router.push("/user-role/edit")
      },
      getUserRoleTable(page) {
        this.isLoading = true;
        this.$store.dispatch("UserRole/getUserRole", {
          page,
          search : this.search,
          sort_date : this.sort_date,
        }).then(res=>{
          this.dataTable = res.data;
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get user role','error');
          this.isLoading = false;
        })
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getUserRoleTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      showUserRoleData(id) {
        this.isLoading = true;
        this.$store.dispatch("UserRole/showUserRole",id).then(res=>{
          if(res.response_code == 200){
            this.$store.dispatch("UserRole/setFormUserRole",res.result);
            this.goToUserRoleEdit();
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get user role','error');
          this.isLoading = false;
        })
      },
      createUserRole() {
        this.$store.dispatch("UserRole/clearFormData").then(()=>{
          this.goToUserRoleEdit();
        })
      },
      searchInput(val){
        this.search = val;
      },
      sortDataTable(){
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
        this.getUserRoleTable(1);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/table.css";
  @import "../../../assets/css/variables";
  .branch-data {
    background-color: $background-theme;
    margin: 20px;
  }
</style>
